export default "__VITE_ASSET__Dbv$0oWA__"